import { LoanProductCategory } from '@appTypes/LoansApi.interface'

import { categories } from '@config/categories'

export const getCategoryPathForId = (categoryId: LoanProductCategory) => {
    return categories[categoryId]?.path
}
